export default __webpack_public_path__ + "static/media/bar-games.614d091f.svg";